<template>
  <div id="app"  v-loading.fullscreen.lock="this.getPDFViewerURL == ''">
    <iframe 
      id="pdfviewer"
      :src="this.getPDFViewerURL"
      type="application/pdf"
      frameborder="0">
      Your browser doesn't support iframes
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'Home',
  computed: {
    ...mapGetters("situation0004", [
        "getPDFViewerURL",
    ]),
	},
  mounted(){
    var pdfCombinedArray = this.$session.get('pdfCombinedArray');
    if(pdfCombinedArray != undefined && pdfCombinedArray != null && pdfCombinedArray.length > 0) {
      if(pdfCombinedArray[0].is_mail == false){
        this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    margin: 0;
}
iframe{
  width: 100%;
  height: 100%;
  position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;
}
/**************PDF viewer in modal popup CSS**********/
</style>